module.exports = __webpack_public_path__ + "media/images/TA-67f05a052eec0b8fe3c9fdb78a93fa9e.png";